import React, {useEffect} from 'react';
import {useViewportSize} from '@sail/helm';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<React.PropsWithChildren<LayoutProps>> = ({
  children,
}) => {
  const {scrollbarWidth} = useViewportSize();

  useEffect(() => {
    if (scrollbarWidth && typeof document !== 'undefined') {
      document.documentElement.style.setProperty(
        '--scrollbarWidth',
        `${scrollbarWidth}px`,
      );
    }
  }, [scrollbarWidth]);

  return <>{children}</>;
};
